import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Home } from "./pages/Home";
import { History } from "./pages/History";
import { Programme } from "./pages/Programme";
import { Participate } from "./pages/Participate";
import { Partners } from "./pages/Partners";
import { Contact } from "./pages/Contact";
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3f8na36cw0p2r">
      <Routes data-id="element-1" data-mp="2rkdwgrptv7mp">
        <Route path="/" element={<Home data-id="element-3" data-mp="2rlf7iw6ufu4f" />} data-id="element-2" data-mp="2rk47n7gir6il" />
        <Route path="/histoire" element={<History data-id="element-5" data-mp="2mm2nej7cx15j" />} data-id="element-4" data-mp="2rit1x23ijoou" />
        <Route path="/programme" element={<Programme data-id="element-7" data-mp="2mnng03a42a0r" />} data-id="element-6" data-mp="2mmvkstkfeeb0" />
        <Route path="/participer" element={<Participate data-id="element-9" data-mp="31ayqs2ygxpzt" />} data-id="element-8" data-mp="31aqeac69cmp5" />
        <Route path="/partenaires" element={<Partners data-id="element-11" data-mp="31cjk5p91r2w3" />} data-id="element-10" data-mp="31c9vq63nh3si" />
        <Route path="/contact" element={<Contact data-id="element-13" data-mp="2wj8f9tnsow6t" />} data-id="element-12" data-mp="2wjgp1comflds" />
        <Route path="*" element={<Home data-id="element-15" data-mp="28ufnm9e7hai0" />} data-id="element-14" data-mp="2whx9joashed2" />
      </Routes>
    </BrowserRouter>;
}